module["exports"] = [
  "IF",
  "FF",
  "BK",
  "HK",
  "AIF",
  "SK",
  "FC",
  "SK",
  "BoIS",
  "FK",
  "BIS",
  "FIF",
  "IK"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/team/suffix.js
// module id = 1065
// module chunks = 0